/* nplus-gift-bundle.js — <nplus-gift-bundle> UI element.
   Classic script, loaded after nplus-cart.js. UI only; no cart calls. */
(function () {
  'use strict';

  class NplusGiftBundle extends HTMLElement {
    connectedCallback() {
      var cfgEl = this.querySelector('.nplus-gift__config');
      try { this.config = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); }
      catch (e) { this.config = { variants: [] }; }

      this.includeEl = this.querySelector('[data-nplus-gift-include]');
      this.variantsWrap = this.querySelector('[data-nplus-gift-variants]');
      this.variantInputs = Array.prototype.slice.call(
        this.querySelectorAll('[data-nplus-gift-variant]')
      );

      // Default the selection to the first available variant.
      var firstAvailable = (this.config.variants || []).filter(function (v) { return v.available; })[0];
      this.defaultVariantId = firstAvailable ? String(firstAvailable.id) : null;
      this.preselectDefault();

      if (this.includeEl) {
        this.includeEl.addEventListener('change', this.onToggle.bind(this));
      }
      this.onToggle(); // sync initial state
    }

    preselectDefault() {
      if (!this.defaultVariantId) return;
      var match = this.variantInputs.filter(function (i) { return i.value === this.defaultVariantId; }, this)[0];
      if (match) match.checked = true;
    }

    onToggle() {
      var included = !!(this.includeEl && this.includeEl.checked);
      if (included) this.setAttribute('data-included', '');
      else this.removeAttribute('data-included');
      if (this.variantsWrap) this.variantsWrap.hidden = !included || this.variantInputs.length === 0;
    }

    // Public API consumed by <nplus-buybox>.
    getSelection() {
      var included = !!(this.includeEl && this.includeEl.checked);
      var variantId = this.defaultVariantId;
      if (this.variantInputs.length) {
        var checked = this.variantInputs.filter(function (i) { return i.checked; })[0];
        variantId = checked ? checked.value : null;
      } else if (this.config.variants && this.config.variants.length === 1) {
        variantId = String(this.config.variants[0].id);
      }
      return { included: included, variantId: variantId };
    }
  }

  if (!customElements.get('nplus-gift-bundle')) {
    customElements.define('nplus-gift-bundle', NplusGiftBundle);
  }
})();
